"use client";

import { useEffect, useState } from "react";

function getScrollRatio() {
  const height = document.documentElement.scrollHeight - window.innerHeight;
  if (height <= 0) return 0;
  return window.scrollY / height;
}

export default function ReMindStickyCtaEn() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const ratio = getScrollRatio();
      const contact = document.getElementById("contact");
      const nearContact = contact
        ? contact.getBoundingClientRect().top < window.innerHeight * 0.9
        : false;

      setVisible(ratio >= 0.4 && !nearContact);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      className={`pointer-events-none fixed bottom-5 right-5 z-[80] transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
      }`}
    >
      <div className="pointer-events-auto rounded-2xl border border-[#17352f]/18 bg-[#fbf8f2]/96 p-2 shadow-[0_18px_44px_rgba(17,35,31,0.18)] backdrop-blur-md">
        <a
          href="#contact"
          className="inline-flex items-center justify-center rounded-xl bg-[#17352f] px-4 py-2.5 text-[0.68rem] font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-200 hover:bg-[#0f241f]"
        >
          Request a quote
        </a>
      </div>
    </div>
  );
}
